import Cards from "../src/Components/Cards";
import LightMode from '../src/Components/DarkModeToLightMode';
import Toggle from "./Components/Toggle";


function App() {
  return (

    <>
      <Toggle/>
    </>

  );
}

export default App;
